module.exports = __webpack_public_path__ + "img/mettingfenxi.436cd5b1.png";